import React from 'react'
import './styles.scss'
const Icon = ({component}: any) => {
  if(!component.icons) return <></>
  return (
    <div className="icon_component">
        {component.icons.map((Icon: any, i: number) => {
            return <Icon 
                size={component.width}
                style={(component.style && component.style[i]) || {}} 
                color={"var(--cambium-brand-color)"} 
                key={i}/>
        })}
    </div>
  )
}

export default Icon
